/* 🤖 this file was generated by svg-to-ts */
export const matIconNat: {
  name: 'nat';
  data: string;
} = {
  name: 'nat',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6.82 13H11v-2H6.82C6.4 9.84 5.3 9 4 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/><path d="m23 12-4-3v2h-4.05c-.5-5.05-4.76-9-9.95-9v2c4.42 0 8 3.58 8 8s-3.58 8-8 8v2c5.19 0 9.45-3.95 9.95-9H19v2l4-3z"/></svg>`
};
